<template>
  <!-- <MarkedParser
    :md="data"
    :class="[$style.copy, dropCap && $style.dropCap]"
    :data-article-id="articleId || undefined"
    data-article-v="3.0.1"
  /> -->
  <div
    :class="[$style.copy, dropCap && $style.dropCap]"
    :data-article-id="articleId || undefined"
    data-article-v="3.0.1"
    v-html="data"
  />
</template>

<script setup lang="ts">
defineProps<{
  data: string
  dropCap?: boolean
  articleId?: string
}>()
</script>

<style lang="scss" module>
.copy {
  width: 100%;
  max-width: var(--article-body-max-width, 54rem);
  margin: 0 auto;

  line-height: math.div(30, 19);
  @include fluid-type(16px, 18px);

  auto-card {
    color: var(--purple);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--roboto-condensed);
    color: #000;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  hr,
  pre,
  img,
  table {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  h1 {
    @include fluid-type(32px, 66px);
    line-height: math.div(70px, 66px);
  }

  h2 {
    @include fluid-type(28px, 52px);
    line-height: math.div(54px, 52px);
  }

  h3 {
    @include fluid-type(26px, 42px);
    line-height: math.div(46px, 42px);
  }

  h4 {
    @include fluid-type(24px, 33px);
    line-height: math.div(37px, 33px);
  }

  h5 {
    @include fluid-type(22px, 29px);
    line-height: math.div(30px, 25px);
  }

  h6 {
    @include fluid-type(20px, 25px);
    line-height: math.div(30px, 25px);
  }

  a {
    color: var(--purple);
    text-decoration: underline;

    &:hover,
    &:focus {
      color: var(--purple-light);
    }
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  li p:last-child {
    margin-bottom: 0;
  }

  pre,
  code {
    font-family:
      ui-monospace,
      SFMono-Regular,
      SF Mono,
      Menlo,
      Monaco,
      Consolas,
      Liberation Mono,
      Courier New,
      monospace;
  }

  pre {
    background: #262626;
    color: #f3f4f6;
    border: 1px solid #3b3b3b;
    border-radius: 10px;
    padding: 16px 18px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    line-height: 1.55;
  }

  pre code {
    display: block;
    white-space: pre;
    background: transparent;
    color: inherit;
    padding: 0;
  }

  :not(pre) > code {
    background: #f3f4f6;
    color: #1f2937;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 0.92em;
    white-space: break-spaces;
  }

  &.dropCap > p:first-child:first-letter {
    font-size: 3.25em;
    font-weight: bold;
    line-height: 0.9;
    float: left;
    padding-right: 4px;
  }
}

:global {
  :local(.copy) {
    iframe {
      max-width: 100%;
    }
  }
}
</style>
